import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import api from "../../apiClient";
import Pagination from "../../Pagination";
import Footer from "../Footer";
import './Company.css';

const JobboxCompanyPage = () => {
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [companyType, setCompanyType] = useState('');
  const [industryType, setIndustryType] = useState('');
  const [location, setLocation] = useState('');
  const [companyTypes, setCompanyTypes] = useState([]);
  const [industryTypes, setIndustryTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const navigate = useNavigate();

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem('currentCompanyPage', selectedPage);
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const companyTypesResponse = await api.getCompanyTypes();
        setCompanyTypes(companyTypesResponse.data);

        const industryTypesResponse = await api.getIndustryTypes();
        setIndustryTypes(industryTypesResponse.data);

        const locationsResponse = await api.getLocationBasedCompanies();
        setLocations(locationsResponse.data);
      } catch (error) {
        // Optionally, you can set an error state to display an error message to the user
      }
    };

    fetchFilterData();
  }, []);

  const handleCompanyTypeChange = (e) => {
    const value = e.target.value;
    if (value === 'all') {
      setCompanyType(''); // or whatever the default value you want
    } else {
      setCompanyType(value);
    }
    localStorage.setItem('currentCompanyPage', 0);
  };

  const handleIndustryTypeChange = (e) => {
    const value = e.target.value;
    if (value === 'all') {
      setIndustryType(''); // or whatever the default value you want
    } else {
      setIndustryType(value);
    }
    localStorage.setItem('currentCompanyPage', 0);
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
    localStorage.setItem('currentCompanyPage', 0);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {

        // const storedPage = localStorage.getItem('currentCompanyPage');
        // const storedPageSize = localStorage.getItem('currentCompanyPageSize');

        // if (storedPage) {
        //   setPage(Number(storedPage));
        // }

        // if (storedPageSize) {
        //   setPageSize(Number(storedPageSize));
        // }
        const response = await api.fetchCompanies({
          search,
          page:  page, //storedPage ? Number(storedPage) :
          pageSize:  pageSize, //storedPageSize ? Number(storedPageSize) :
          companyType,
          industryType,
          location,
        });
        if (response.data.content.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Company not found!"
          });
          setSearch('');
          setLocation('');
        }
        setCompanies(response.data.content);
        setTotalPages(response.data.totalPages);
      } catch (error) {
      }
    };
    fetchData();
  }, [search, page, pageSize, companyType, industryType, location]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    localStorage.setItem('currentCompanyPage', 0);
  };



  // const handleClick = (companyId) => {
  //   navigate("/companyPage", { state: { companyId } });
  // };
  const handleClick = (companyId) => {
    const company = companies.find((company) => company.companyId === companyId);
    if (company) {
      const encodedCompanyName = encodeURIComponent(company.companyName); // Encode the company name
      navigate(`/companyPage/companyName/${encodedCompanyName}`, { state: { companyId } });
      // Trigger a page reload after navigating
      // window.location.reload();
      // window.open(`/companyPage/companyName/${encodedCompanyName}?companyId=${companyId}`, '_blank');
    } else {
    }
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;
  const homeUrl = window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : "https://jobbox.one";

  return (
    <div
  style={{
    overflowX: 'hidden',
    backgroundColor: '#ffffff',
  }}
>
  <div className="welcome-msg">
    <div
      className="d-flex flex-column justify-content-between"
      style={{
        marginLeft: '12px',
        marginRight: '12px',
      }}
    >

      {/* Logo */}
      <div
        style={{
          padding: '10px 0 15px 5px',
        }}
      >
        <a href={homeUrl}>
          <img
            src="/jb_logo.png"
            alt="JobBox Logo"
            style={{
              width: '200px',
              height: 'auto',
              maxHeight: '100px',
              cursor: 'pointer',
              objectFit: 'contain',
            }}
          />
        </a>
      </div>

      {/* Filter Section */}
      <Row
        className="d-flex flex-wrap gx-3"
        style={{
          backgroundColor: '#f7f7fb',
          border: '1px solid #e5e5ec',
          borderRadius: '10px',
          marginLeft: '0',
          marginRight: '0',
          padding: '12px 10px 8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        }}
      >

        {/* Company Type */}
        <Col
          md={3}
          xs={12}
          className="mb-2"
          style={{
            margin: '3px 0',
          }}
        >
          <label
            htmlFor="companyType"
            className="form-label"
            style={{
              color: '#6c5b7b',
              fontWeight: '600',
              fontSize: '14px',
              marginBottom: '6px',
            }}
          >
            Select Company Type
          </label>

          <select
            id="companyType"
            className="form-select form-select-sm fs-6"
            style={{
              borderColor: '#d8d3df',
              borderRadius: '7px',
              width: '100%',
              height: '40px',
              backgroundColor: '#ffffff',
              boxShadow: 'none',
            }}
            value={companyType}
            onChange={handleCompanyTypeChange}
          >
            <option value="all">All</option>

            {companyTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </Col>

        {/* Industry */}
        <Col
          md={3}
          xs={12}
          className="mb-2"
          style={{
            margin: '3px 0',
          }}
        >
          <label
            htmlFor="industryType"
            className="form-label"
            style={{
              color: '#6c5b7b',
              fontWeight: '600',
              fontSize: '14px',
              marginBottom: '6px',
            }}
          >
            Select Industry
          </label>

          <select
            id="industryType"
            className="form-select form-select-sm fs-6"
            style={{
              borderColor: '#d8d3df',
              borderRadius: '7px',
              width: '100%',
              height: '40px',
              backgroundColor: '#ffffff',
              boxShadow: 'none',
            }}
            value={industryType}
            onChange={handleIndustryTypeChange}
          >
            <option value="all">All</option>

            {industryTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </Col>

        {/* Location */}
        <Col
          md={3}
          xs={12}
          className="mb-2"
          style={{
            margin: '3px 0',
          }}
        >
          <label
            htmlFor="location"
            className="form-label"
            style={{
              color: '#6c5b7b',
              fontWeight: '600',
              fontSize: '14px',
              marginBottom: '6px',
            }}
          >
            Search Location
          </label>

          <input
            type="text"
            id="location"
            style={{
              height: '40px',
              borderRadius: '7px',
              width: '100%',
              border: '1px solid #d8d3df',
              padding: '8px 12px',
              backgroundColor: '#ffffff',
              outline: 'none',
              fontSize: '14px',
            }}
            placeholder="Enter location"
            value={location}
            onChange={handleLocationChange}
          />
        </Col>

        {/* Company Search */}
        <Col
          md={3}
          xs={12}
          className="mb-2"
          style={{
            margin: '3px 0',
          }}
        >
          <label
            htmlFor="search"
            className="form-label"
            style={{
              color: '#6c5b7b',
              fontWeight: '600',
              fontSize: '14px',
              marginBottom: '6px',
            }}
          >
            Search Company
          </label>

          <input
            type="text"
            name="search"
            id="search"
            placeholder="Search company by name"
            value={search}
            onChange={handleSearchChange}
            style={{
              height: '40px',
              borderRadius: '7px',
              width: '100%',
              border: '1px solid #d8d3df',
              padding: '8px 12px',
              backgroundColor: '#ffffff',
              outline: 'none',
              fontSize: '14px',
            }}
          />
        </Col>
      </Row>

      {/* Company Cards */}
      <Row
        className="cards flex-grow-1 d-flex flex-wrap"
        style={{
          minHeight: 'fit-content',
          width: '100%',
          marginLeft: '0',
          marginTop: '24px',
        }}
      >
        {companies.length > 0 ? (
          companies.map((company) => (
            <Col
              xs={12}
              sm={6}
              md={4}
              className="d-flex justify-content-center mb-4"
              key={company.companyId}
            >
              <Card
                className="company-card-job"
                style={{
                  width: '100%',
                  maxWidth: '380px',
                  minHeight: '220px',
                  border: '1px solid #e6e3ea',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.2s ease',
                }}
              >
                <Card.Body
                  style={{
                    padding: '20px',
                  }}
                >
                  <Row
                    className="align-items-start"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      minHeight: '70px',
                    }}
                  >

                    {/* Company Name */}
                    <Col xs={8} className="text-start">
                      <Card.Title
                        style={{
                          fontSize: '18px',
                          fontWeight: '600',
                          color: '#302b36',
                          lineHeight: '1.4',
                          marginBottom: '0',
                          wordBreak: 'break-word',
                        }}
                      >
                        {company.companyName}
                      </Card.Title>
                    </Col>

                    {/* Company Logo */}
                    <Col
                      xs={4}
                      className="text-end"
                    >
                      <div
                        style={{
                          width: '70px',
                          height: '60px',
                          marginLeft: 'auto',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '8px',
                          backgroundColor: '#f8f8fa',
                          padding: '6px',
                        }}
                      >
                        <img
                          src={
                            company.logo
                              ? `data:image/png;base64,${company.logo}`
                              : 'https://static.vecteezy.com/system/resources/previews/013/899/376/original/cityscape-design-corporation-of-buildings-logo-for-real-estate-business-company-vector.jpg'
                          }
                          alt={`${company.companyName} logo`}
                          style={{
                            maxWidth: '58px',
                            maxHeight: '50px',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain',
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                 
                  {/* Industry */}
                  <Card.Text
                    style={{
                      fontSize: '14px',
                      color: '#66616b',
                      marginBottom: '18px',
                    }}
                  >
                    <span
                      style={{
                        fontWeight: '500',
                        color: '#77717d',
                      }}
                    >
                      Industry:
                    </span>{' '}
                    <b
                      style={{
                        color: '#3f3945',
                      }}
                    >
                      {company.industryService || 'Not mentioned'}
                    </b>
                  </Card.Text>

                  {/* View Button */}
                  <Button
                    onClick={() => handleClick(company.companyId)}
                    style={{
                      backgroundColor: '#890bf8',
                      borderColor: '#8809f7',
                      borderRadius: '7px',
                      padding: '7px 20px',
                      fontSize: '14px',
                      fontWeight: '500',
                    }}
                  >
                    View
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: '100%',
              minHeight: '250px',
            }}
          >
            <div className="spinner-bubble spinner-bubble-primary m-4" />
            <span
              style={{
                color: '#66616b',
                fontSize: '14px',
              }}
            >
              Loading...
            </span>
          </div>
        )}
      </Row>
    </div>

    {/* Pagination */}
    {companies.length > 0 && (
      <div
        style={{
          marginTop: '5px',
          marginBottom: '20px',
        }}
      >
        <Pagination
          page={page}
          pageSize={pageSize}
          totalPages={totalPages}
          handlePageSizeChange={handlePageSizeChange}
          isPageSizeDisabled={isPageSizeDisabled}
          handlePageClick={handlePageClick}
        />
      </div>
    )}
  </div>

  <Footer />
</div>
  );
};

export default JobboxCompanyPage;
